export default "__VITE_ASSET__CVvsdsT1__"